import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={111}
      height={95}
      viewBox="0 0 111 95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M70.57 22.21a8.67 8.67 0 100-17.34 8.67 8.67 0 000 17.34z"
        fill="#E4C000"
      />
      <Path
        d="M44.467 55.264c0 16.745-9.954 22.591-22.234 22.591C9.954 77.855 0 72.009 0 55.265 0 38.52 22.233 17.217 22.233 17.217S44.467 38.52 44.467 55.264z"
        fill="#F2F2F2"
      />
      <Path
        d="M21.424 75.294l.227-14.014 9.477-17.337-9.441 15.139.102-6.301 6.531-12.543-6.504 10.875L22 39.781l6.994-9.986-6.965 8.204.115-20.78-.722 27.509.059-1.135-7.11-10.884 6.996 13.062-.663 12.657-.02-.336-8.197-11.454 8.173 12.64-.083 1.584-.015.023.007.13-1.681 32.111h2.246l.27-16.586 8.152-12.609-8.132 11.363z"
        fill="#3F3D56"
      />
      <Path
        d="M110.353 46.48c0 20.456-12.16 27.598-27.162 27.598-15.001 0-27.162-7.142-27.162-27.598S83.19 0 83.19 0s27.162 26.023 27.162 46.48z"
        fill="#F2F2F2"
      />
      <Path
        d="M82.201 70.95l.279-17.12 11.577-21.18-11.534 18.494.125-7.698 7.98-15.324L82.68 41.41l.225-13.845 8.544-12.2-8.508 10.023L83.082 0 82.2 33.607l.073-1.386-8.687-13.297 8.547 15.958-.81 15.463-.023-.41-10.015-13.993 9.984 15.442-.1 1.934-.019.029.008.159-2.053 39.23h2.743l.33-20.264 9.96-15.404L82.2 70.949z"
        fill="#3F3D56"
      />
      <Path
        d="M54.18 94.275c23.042 0 41.722-.667 41.722-1.49s-18.68-1.49-41.722-1.49c-23.043 0-41.722.667-41.722 1.49s18.68 1.49 41.722 1.49z"
        fill="#3F3D56"
      />
      <Path d="M56.623 33.053h-4.877V92.79h4.877V33.053z" fill="#2F2E41" />
      <Path
        d="M76.531 45.238H46.594V36.84h29.937l8.67 4.199-8.67 4.2z"
        fill="#3D3C42"
      />
      <Path
        opacity={0.1}
        d="M76.531 44.561H46.594v.677h29.937l8.67-4.199-.7-.339-7.97 3.861z"
        fill="#000"
      />
      <Path d="M68.539 38.465H63.39v5.148h5.148v-5.148z" fill="#E40046" />
      <Path
        d="M54.18 42.258a1.49 1.49 0 100-2.98 1.49 1.49 0 000 2.98z"
        fill="#2F2E41"
      />
      <Path
        d="M25.191 59.055l29.937-.812v-6.774l-29.937-.812-8.67 4.199 8.67 4.2z"
        fill="#3D3C42"
      />
      <Path
        opacity={0.1}
        d="M17.22 54.517l-.698.339 8.67 4.2 29.936-.813v-.678l-29.937.813-7.97-3.86z"
        fill="#000"
      />
      <Path
        d="M35.893 57.43a2.574 2.574 0 100-5.148 2.574 2.574 0 000 5.148z"
        fill="#E40046"
      />
      <Path
        d="M47.407 56.075a1.49 1.49 0 100-2.98 1.49 1.49 0 000 2.98z"
        fill="#2F2E41"
      />
      <Path
        d="M39.091 72.065l12.655.271v-7.45l-12.655.406-2.11 3.387 2.11 3.386z"
        fill="#2B2A2C"
      />
      <Path
        d="M46.734 71.252c.673 0 1.22-1.152 1.22-2.573 0-1.422-.547-2.574-1.22-2.574-.673 0-1.22 1.152-1.22 2.574 0 1.421.547 2.573 1.22 2.573z"
        fill="#E40046"
      />
      <Path
        d="M44.156 87.683c0 3.044-1.81 4.106-4.041 4.106a6.66 6.66 0 01-.462-.015c-2.015-.143-3.58-1.26-3.58-4.09 0-2.93 3.744-6.627 4.025-6.9l.017-.016s4.04 3.871 4.04 6.915z"
        fill="#89D167"
      />
      <Path
        d="M39.967 91.324l1.478-2.066-1.481 2.293-.004.237a6.57 6.57 0 01-.307-.014l.159-3.045-.001-.024.002-.004.015-.288-1.485-2.298 1.49 2.082.004.061.12-2.3-1.272-2.375 1.287 1.97.126-4.77v-.015.015l-.02 3.762 1.265-1.492-1.27 1.816-.034 2.06 1.182-1.977-1.187 2.28-.019 1.145 1.716-2.752-1.722 3.152-.042 2.547z"
        fill="#3F3D56"
      />
    </Svg>
  );
}

export default SvgComponent;
